import api from './api';

/**
 * Fetch the latest currency rate (public).
 * Returns the most recent CurrencyRate entry.
 * Base is Naira, target is Chinese Yuan; base_currency_rate = Naira per 1 Yuan.
 */
export const fetchLatestCurrencyRate = async () => {
  const { data } = await api.get('/currency-rates/latest');
  return data;
};
